export default class Instagram {

	/** @var {HTMLElement} #element */
	#element;

	/** @var {HTMLElement} #feedElement */
	#feedWrapper;


	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		if (!element.dataset.instagramUsername) {
			console.warn('Cannot display Instagram feed, missing username.');
			return;
		}
		const feedWrapper = element.querySelector('.feed');
		if (!feedWrapper) {
			return;
		}
		this.#element = element;
		this.#feedWrapper = feedWrapper;
		this.#delayLoad();
	}


	#delayLoad() {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					void this.#load();
					observer.unobserve(this.#element);
				}
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.01,
		});
		observer.observe(this.#element);
	}


	async #load() {
		const baseUrl = `/instagram/${this.#element.dataset.instagramUsername}`;
		const feedUrl = `${baseUrl}/feed.json`;
		const response = await fetch(feedUrl);
		if (!response.ok) {
			console.warn(`Could not get Instagram feed. HTTP status: ${response.status}`);
			return;
		}
		const instagramLink = 'https://www.instagram.com/' + this.#element.dataset.instagramUsername;
		const feed = await response.json();
		const images = [];
		let count = 0;
		for (const filename of feed) {
			if (count > 4) {
				break;
			}
			const img = document.createElement('img');
			img.src = `${baseUrl}/${filename}`;
			img.loading = 'lazy';

			const a = document.createElement('a');
			a.href = instagramLink;
			a.target = '_blank';
			a.append(img);
			images.push(a);
			count++;
		}
		this.#feedWrapper.append(...images);
	}

}
